// Re-export shim — the hooks and module commands moved verbatim into
// `@heidi/session/data` (D5, ARCFE-990). Nothing app-coupled remained: the
// token crosses the seam and the compare util was promoted to @heidi/utils.
//
// LOAD-BEARING side-effect imports, kept from the legacy module's own value
// imports in their original order: `@/lib/utils` is the app's documented
// store-cycle breaker (_app.tsx imports it at the top for exactly this), and
// `@/pages/api/scribeAPIV2` reaches `@/utils/scribeHTTP`, which value-imports
// `@/store` — together they initialize the store↔scribeRecordModel cycle
// from the safe direction for any suite that imports this shim before a real
// `@/models/scribeRecordModel` import. Verbatim moves preserve IMPORT
// GRAPHS, not just code. Deleted with this shim at Z2.
import '@/lib/utils';
import '@/pages/api/scribeAPIV2';

export {
  GET_SESSION_CONTEXT_FILES,
  GET_SESSION_CONTEXT_FILES_PROGRESS,
  getSessionContextFilesFromCache,
  invalidateContextFiles,
  useQuerySessionContextFileProgress,
  useQuerySessionContextFiles,
  type QuerySessionContextFile,
  type SessionContextFileProgress,
} from '@heidi/session/data';
